export const USER_TYPES = {
  ADMIN: "admin",
  MANAGER: "manager",
  CARER: "carer",
  USER: "user",
  SUPERVISOR: "supervisor",
};